export var ParentType;
(function (ParentType) {
    ParentType["Mother"] = "Mother";
    ParentType["Father"] = "Father";
    ParentType["Stepfather"] = "Stepfather";
    ParentType["Stepmother"] = "Stepmother";
    ParentType["FosterParent"] = "FosterParent";
    ParentType["Parent1"] = "Parent1";
    ParentType["Parent2"] = "Parent2";
    ParentType["Other"] = "Other";
})(ParentType || (ParentType = {}));
export class ParentTypeHelper {
    static getName(type) {
        switch (type) {
            case ParentType.Mother:
                return $t(`%2Z`);
            case ParentType.Father:
                return $t(`%2Y`);
            case ParentType.Stepmother:
                return $t(`%qd`);
            case ParentType.Stepfather:
                return $t(`%qe`);
            case ParentType.Parent1:
                return $t(`%qf`);
            case ParentType.Parent2:
                return $t(`%qg`);
            case ParentType.Other:
                return $t(`%qh`);
            case ParentType.FosterParent:
                return $t(`%qi`);
        }
    }
    static getPublicTypes() {
        return [ParentType.Mother, ParentType.Father, ParentType.Stepmother, ParentType.Stepfather, ParentType.FosterParent, ParentType.Other];
    }
}
//# sourceMappingURL=ParentType.js.map